import React from "react";
import { Col, Row, Form, Input, Card } from "antd";
import InputTelefone from "./Input-telefone";

const Contato = ({ nome, ocultarTitulo = false }) => {
  return (
    <div>
      {/*<div hidden={ocultarTitulo}>
            <h2 className="legend">Contato(s)</h2>
            <div className="linha-legenda"></div>
        </div>*/}
      <Row gutter={[24, 24]}>
        <Col style={{ width: "100%" }}>
          <Card title="Telefone Principal">
            <Col span={12}>
              <Form.Item name={["contato", "telefone1Id"]} hidden>
                <Input />
              </Form.Item>

              <Form.Item
                name={[nome, "telefone1"]}
                label="Telefone"
                rules={[{ required: true, min: 14 }]}
              >
                <InputTelefone className="ant-input" />
              </Form.Item>
            </Col>
          </Card>
        </Col>

        <Col style={{ width: "100%" }}>
          <Card title="Telefone Contato">
            <Col span={12}>
              <Form.Item name={["contato", "telefoneContatoId"]} hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name={[nome, "telefoneContato"]}
                label="Telefone"
                rules={[{ min: 14 }]}
              >
                <InputTelefone className="ant-input" />
              </Form.Item>
            </Col>
          </Card>
        </Col>

        {/*<Col span={4}>
            <Form.Item name={[nome, "telefone2"]} label="Whatsapp" rules={[{min:14}]}>
                <InputTelefone className="ant-input" />
            </Form.Item>
        </Col>
        <Col span={12}>
            <Form.Item name={[nome, "email"]} label="E-Mail" rules={[
                { required: true, message: "O e-mail é obrigatório!" },
                { type: "email", message: "Digite um e-mail válido!" }]}
            >
                <Input />
            </Form.Item>
        </Col>*/}
        <Col style={{ width: "100%" }}>
          <Card title="E-mail">
            <Col span={12}>
              <Form.Item
                name={[nome, "email"]}
                label="E-Mail"
                rules={[
                  { required: true, message: "O e-mail é obrigatório!" },
                  { type: "email", message: "Digite um e-mail válido!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Contato;
